import { render } from "./SeriesLink.vue?vue&type=template&id=bfa8ced8&scoped=true"
import script from "./SeriesLink.vue?vue&type=script&lang=js"
export * from "./SeriesLink.vue?vue&type=script&lang=js"

import "./SeriesLink.vue?vue&type=style&index=0&id=bfa8ced8&scoped=true&lang=css"

import exportComponent from "/home/forge/tester.cl-planner.com/releases/62689321/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfa8ced8"]])

export default __exports__